import { useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import { loadDanalPaymentsSDK } from '@danalpay/javascript-sdk'
import { decryptPhoneNumber, handleJsonParse } from 'src/utils'
import { DanalPayMethodType } from 'src/types/api'

const Danal = () => {
  const [searchParams] = useSearchParams()
  const isGift = searchParams.get('isGift')
  const data = handleJsonParse(decryptPhoneNumber(searchParams.get('data')!))
  const { itemName, amount, orderId, payMethod } = data
  const returnUrl = `${
    isGift === 'true'
      ? process.env.REACT_APP_PAYMENT_GIFT_RETURN_URL
      : process.env.REACT_APP_PAYMENT_RETURN_URL
  }/danal`

  useEffect(() => {
    loadDanalPaymentsSDK({
      clientKey: process.env.REACT_APP_PAYMENT_DANAL_CLIENT_KEY as string,
    }).then((danalPayments) => {
      danalPayments.requestPayment({
        orderName: `${itemName}`,
        amount: Number(amount),
        merchantId: `${process.env.REACT_APP_PAYMENT_DANAL_MERCHANT_ID}`,
        orderId: `${orderId}`,
        userId: 'user@example.com',
        successUrl: `${returnUrl}`,
        failUrl: `${returnUrl}/fail/${orderId}`,
        paymentsMethod: `${payMethod as DanalPayMethodType}`,
        itemType: '1',
        itemCode: `${process.env.REACT_APP_PAYMENT_DANAL_ITEM_CODE}`, //휴대폰결제용 아이템코드
      })
    })
  }, [])

  return <></>
}

export default Danal
